import React from 'react';
import { MdEmail } from 'react-icons/md';
import styles from './Login.module.css';

const EmailStep = ({
    email,
    setEmail,
    rememberMe,
    setRememberMe,
    onSubmit,
    loading,
    error
}) => {
    return (
        <form onSubmit={onSubmit} className={styles.form}>
            <div className={styles.inputGroup}>
                <label className={styles.inputLabel}>Enter Your Email Address</label>
                <div className={styles.inputWrapper}>
                    <MdEmail className={styles.inputIcon} />
                    <input
                        type="email"
                        placeholder="name@company.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className={styles.input}
                        required
                        disabled={loading}
                        autoFocus
                    />
                </div>
            </div>

            <div className={styles.formOptions}>
            </div>

            {error && (
                <div className={styles.errorAlert}>
                    <span className={styles.errorIcon}>⚠</span>
                    <span>{error}</span>
                </div>
            )}

            <button type="submit" className={styles.submitBtn} disabled={loading}>
                {loading ? (
                    <>
                        <span className={styles.spinner}></span>
                        Sending...
                    </>
                ) : (
                    'Send Verification Code'
                )}
            </button>
        </form>
    );
};

export default EmailStep;